import { ActionIcon, Group, Image, Select, Tooltip } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import dayjs from "dayjs";
import classes from "../AdminDashboardView/AdminDashboardView.module.css";
import { applyDashboardRangeField } from "../../utils/dashboardDateRange";

const AdminInlineFilters = ({ fromDate, toDate, setFromDate, setToDate, scope, setScope }) => {
  const rangeState = { startDate: fromDate ?? null, endDate: toDate ?? null };
  const maxSelectable = new Date();

  const handleFromChange = (value) => {
    const next = applyDashboardRangeField(rangeState, "startDate", value);
    setFromDate(next.startDate);
    setToDate(next.endDate);
  };

  const handleToChange = (value) => {
    const next = applyDashboardRangeField(rangeState, "endDate", value);
    setFromDate(next.startDate);
    setToDate(next.endDate);
  };

  return (
    <Group gap={6} wrap="nowrap">
      {typeof setScope === "function" ? (
        <Select
          data={[
            { label: "Both", value: "both" },
            { label: "Domestic", value: "domestic" },
            { label: "International", value: "international" },
          ]}
          value={scope}
          onChange={(value) => setScope(value || "both")}
          className={classes.compactSelect}
          size="xs"
          allowDeselect={false}
        />
      ) : null}
      <DateInput
        value={fromDate}
        onChange={handleFromChange}
        placeholder="From"
        size="xs"
        className={classes.compactDate}
        maxDate={maxSelectable}
      />
      <DateInput
        value={toDate}
        onChange={handleToChange}
        placeholder="To"
        size="xs"
        className={classes.compactDate}
        maxDate={maxSelectable}
        minDate={
          fromDate ? dayjs(fromDate).startOf("day").toDate() : undefined
        }
      />
      {(fromDate || toDate) && (
        <Tooltip label="Reset dates" position="bottom" withArrow fz={11}>
          <ActionIcon
            variant="subtle"
            color="gray"
            size="xs"
            onClick={() => { setFromDate(null); setToDate(null); }}
            aria-label="Reset date filter"
          >
            <Image src="/images/svg/cross.svg" w={10} h={10} />
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  );
};

export default AdminInlineFilters;